{"rating":"4.9","reviewCount":"141","fetchedAt":"2026-10-23T04:38:12.212Z","source":"place-details"}